import loadable from '@loadable/component';
import {
  ACTION_TYPE,
  COMPONENT_NAME,
} from '@skyscanner-internal/landing-pages-shared-constants/constants';

import { BpkAccordion } from '@skyscanner/backpack-web/bpk-component-accordion';
import BpkSectionHeader from '@skyscanner/backpack-web/bpk-component-section-header';

import logMiniEventHelper from '../../mini-event/logMiniEventHelper';
import withErrorBoundary from '../ErrorBoundary/WithErrorBoundary';
import { useMBDContext } from '../common/MBD/useMBDContext';

import AccordionItem from './AccordionItem';

import type { AccordionProps } from '@skyscanner-internal/landing-pages-shared-types/src/types-shared/AccordionProps';

import STYLES from './Accordion.module.scss';

const IntersectionObserverWrapper = loadable(
  () => import('../IntersectionObserverWrapper/IntersectionObserverWrapper'),
);

const Accordion = ({ description, isFaq, items, title }: AccordionProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (!items?.length) {
    return null;
  }

  return (
    <div
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
      className={STYLES.Accordion}
    >
      <BpkSectionHeader title={title} description={description} />
      <BpkAccordion>
        {items.map((item) => (
          <AccordionItem key={item.id} isFaq={isFaq} {...item} />
        ))}
      </BpkAccordion>
    </div>
  );
};

const AccordionWrapper = (props: AccordionProps) => (
  <IntersectionObserverWrapper
    onElementSeen={() =>
      logMiniEventHelper({
        action_type: ACTION_TYPE.COMPONENT_VISIBLE,
        component_name: COMPONENT_NAME.ACCORDION,
      })
    }
  >
    <Accordion {...props} />
  </IntersectionObserverWrapper>
);
const AccordionWithErrorBoundary = withErrorBoundary(
  AccordionWrapper,
  'accordion',
);
export default AccordionWithErrorBoundary;
